// extracted by mini-css-extract-plugin
export default {"container":"_i-z","blurb":"aj-z","links":"bj-z"};